(function(){
'use strict';


var C = window.HavjoyCore;
if (!C) return;

var dataEl = document.getElementById('product-variants-data');
if (!dataEl) return;
var ALL_PRODUCTS;
var collectionConfig;
try {
  collectionConfig = JSON.parse(dataEl.textContent);
  ALL_PRODUCTS = collectionConfig.products || collectionConfig || {};
} catch(e) { console.warn('HJ: product-variants-data parse failed, will fetch on demand', e.message); ALL_PRODUCTS = {}; collectionConfig = {}; }

var modal = document.getElementById('personalize-modal');
if (!modal) return;
var isCollectionTeeCreate = !!(collectionConfig && collectionConfig.collectionTeeCreate) || !!document.querySelector('[data-collection-tee-create="true"]');
var MULTI_PHOTO_MAX = 8;
var MULTI_PHOTO_MIN = 4;

// ===== STATE =====
function createState() {
  return {
    variantId: null, variantTitle: null, price: 0, comparePrice: 0,
    personalizeImage: null, listGenerated: [], productHandle: null,
    options: {}, optionLabels: {}, uploadedUrl: null, uploadedUrls: [], localPhotos: [], galleryIndex: 0,
    printType: 'canvas', sizeKey: '9x12'
  };
}

var state = {};
var intervals = {};
var optionsCache = {};
var variantCardsHandle = null;
var activeHandle = null;

function getState(handle) {
  if (!state[handle]) { state[handle] = createState(); state[handle].productHandle = handle; }
  return state[handle];
}

function setDA(val) { if (modalEls.designActions) modalEls.designActions.style.display = val; }

function isModalStepActive(step) {
  var stepEl = modal.querySelector('.hj-step[data-step="' + step + '"]');
  return !!(stepEl && stepEl.classList.contains('active'));
}

// ===== MODAL ELEMENT CACHE =====
var modalEls = {
  hacard: modal.querySelector('.hacard'),
  loadingArea: modal.querySelector('.loading-area'),
  mainImage: modal.querySelector('.main-image'),
  confirmBtn: modal.querySelector('.confirm-btn'),
  uploadedPreview: modal.querySelector('.uploaded-image-preview'),
  uploadedPreviewImg: modal.querySelector('.uploaded-preview-img'),
  modalFooter: modal.querySelector('.modal-footer'),
  progressBar: modal.querySelector('.progress'),
  prevBtn: modal.querySelector('.prev-btn'),
  nextBtn: modal.querySelector('.next-btn'),
  variantOption: document.getElementById('variant-option-container'),
  generateBtn: modal.querySelector('.generate-btn'),
  designActions: modal.querySelector('.hj-design-actions'),
  smallNote: modal.querySelector('.small-note'),
  optionsContainer: modal.querySelector('.product-options-container'),
  dynamicForm: modal.querySelector('.dynamic-options-form'),
  productHandle: modal.querySelector('.product-handle'),
  genericPhotoPicker: modal.querySelector('[data-generic-photo-picker]'),
  singlePicker: modal.querySelector('[data-single-photo-picker]'),
  singleGrid: modal.querySelector('[data-single-photo-grid]'),
  multiPicker: modal.querySelector('[data-multi-photo-picker]'),
  multiGrid: modal.querySelector('[data-multi-photo-grid]'),
  multiCount: modal.querySelector('[data-multi-photo-count]'),
  teePanel: modal.querySelector('[data-tee-modal-panel]'),
};
var fileInput = document.getElementById('file-input');
var uploader = new C.Uploader();

function getProductData(handle) {
  return ALL_PRODUCTS[handle] || null;
}

function isCollectionTeeCreateHandle(handle) {
  if (!isCollectionTeeCreate) return false;
  if (!handle) return false;
  var productData = getProductData(handle);
  return !productData || productData.teeCreate !== false;
}

function isTeeMultiPhotoHandle(handle) {
  var productData = getProductData(handle);
  return !!(productData && productData.templateSuffix === 'tee-template-multi-photo');
}

function isTeeCreateMultiActive() {
  return isCollectionTeeCreateHandle(activeHandle) && activeHandle && isTeeMultiPhotoHandle(activeHandle) && modalEls.multiPicker && modalEls.multiGrid;
}

function isTeeCreateSingleActive() {
  return isCollectionTeeCreateHandle(activeHandle) && activeHandle && !isTeeMultiPhotoHandle(activeHandle) && modalEls.singlePicker && modalEls.singleGrid;
}

function isCollectionSinglePhotoActive() {
  return isCollectionTeeCreate && activeHandle && (!isCollectionTeeCreateHandle(activeHandle) || !isTeeMultiPhotoHandle(activeHandle)) && modalEls.singlePicker && modalEls.singleGrid;
}

function getTeeVariants(handle) {
  var productData = getProductData(handle);
  return (productData && productData.variants) || [];
}

function getVariantSize(variant) {
  return variant.option1 || variant.title || 'S';
}

function findTeeVariantBySize(handle, size) {
  var variants = getTeeVariants(handle);
  return variants.find(function(variant) {
    return variant.title === size || variant.option1 === size;
  }) || variants[0];
}

function formatMoney(cents) {
  return C.formatMoney(Math.max(0, cents || 0));
}

function escapeHtml(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch) {
    return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[ch];
  });
}

function getUniqueSizes(handle) {
  var seen = {};
  return getTeeVariants(handle).map(getVariantSize).filter(function(size) {
    if (!size || seen[size]) return false;
    seen[size] = true;
    return true;
  });
}

function teePricing(panel, handle) {
  var lines = [];
  var mainVariant = findTeeVariantBySize(handle, panel.querySelector('[data-tee1-size]')?.value || 'S');
  var mainQty = Math.max(1, parseInt(panel.querySelector('[data-tee1-qty]')?.value || '1', 10));
  if (mainVariant) lines.push({ variant: mainVariant, qty: mainQty, size: getVariantSize(mainVariant) });

  panel.querySelectorAll('[data-extra-tee-row]').forEach(function(row) {
    var variant = findTeeVariantBySize(handle, row.querySelector('[data-extra-size]')?.value || '');
    var qty = Math.max(1, parseInt(row.querySelector('[data-extra-qty]')?.value || '1', 10));
    if (variant) lines.push({ variant: variant, qty: qty, size: getVariantSize(variant), row: row });
  });

  var totalQty = lines.reduce(function(sum, line) { return sum + line.qty; }, 0);
  var subtotal = lines.reduce(function(sum, line) { return sum + (line.variant.price || 0) * line.qty; }, 0);
  var rate = totalQty >= 3 ? 0.20 : (totalQty >= 2 ? 0.15 : 0);
  var savings = Math.round(subtotal * rate);
  return { lines: lines, totalQty: totalQty, subtotal: subtotal, savings: savings, total: subtotal - savings };
}

function shopPayLogo() {
  return '<svg style="width:59px;height:14px;vertical-align:middle;color:rgb(84 51 235/1)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99 25"><path fill="currentColor" d="M70.842 7.915h2.25c1.561 0 2.328.642 2.328 1.715 0 1.074-.739 1.715-2.259 1.715h-2.32v-3.43ZM80.525 16.142c-.879 0-1.227-.474-1.227-.948 0-.642.725-.935 2.147-1.102l1.115-.125c-.07 1.227-.892 2.175-2.035 2.175Z"/><path fill="currentColor" fill-rule="evenodd" d="M65.645.5a3.64 3.64 0 0 0-3.64 3.64V20.7a3.64 3.64 0 0 0 3.64 3.64h29.668a3.64 3.64 0 0 0 3.64-3.64V4.14A3.64 3.64 0 0 0 95.314.5H65.645Zm5.197 16.674v-4.197h2.64c2.412 0 3.695-1.353 3.695-3.402 0-2.05-1.283-3.277-3.695-3.277h-4.341v10.876h1.7Zm9.334.223c1.297 0 2.147-.572 2.538-1.548.112 1.088.767 1.645 2.189 1.269l.014-1.157c-.572.055-.683-.154-.683-.753v-2.845c0-1.673-1.102-2.663-3.138-2.663-2.008 0-3.165 1.004-3.165 2.705h1.562c0-.809.572-1.297 1.576-1.297 1.06 0 1.547.46 1.534 1.255v.363l-1.8.195c-2.021.223-3.137.99-3.137 2.329 0 1.101.781 2.147 2.51 2.147Zm9.906.32c-.711 1.73-1.855 2.245-3.64 2.245h-.766V18.54h.822c.977 0 1.45-.307 1.966-1.185L85.3 9.923h1.757l2.259 5.424 2.008-5.424h1.715l-2.956 7.795Z" clip-rule="evenodd"/><path fill="currentColor" d="M6.992 11.055c-2.359-.509-3.41-.708-3.41-1.612 0-.85.711-1.274 2.134-1.274 1.25 0 2.165.544 2.839 1.61.05.081.155.11.241.066l2.655-1.335a.186.186 0 0 0 .076-.259c-1.102-1.9-3.137-2.94-5.818-2.94C2.188 5.311 0 7.037 0 9.781c0 2.915 2.664 3.651 5.027 4.16 2.362.51 3.417.709 3.417 1.613s-.769 1.33-2.303 1.33c-1.416 0-2.467-.644-3.102-1.896a.186.186 0 0 0-.251-.082L.14 16.21a.188.188 0 0 0-.083.253c1.051 2.102 3.207 3.285 6.087 3.285 3.668 0 5.885-1.698 5.885-4.527 0-2.83-2.677-3.651-5.037-4.16v-.007ZM21.218 5.311c-1.505 0-2.835.531-3.791 1.477-.06.057-.159.015-.159-.067V.687A.185.185 0 0 0 17.081.5h-3.322a.185.185 0 0 0-.187.187v18.73c0 .104.083.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-1.587 1.223-2.804 2.87-2.804 1.649 0 2.843 1.191 2.843 2.804v8.216c0 .104.082.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-3.452-2.274-5.89-5.459-5.89ZM33.415 4.774c-1.803 0-3.493.55-4.706 1.343a.186.186 0 0 0-.06.25l1.464 2.488c.054.089.168.12.257.066a5.853 5.853 0 0 1 3.052-.834c2.899 0 5.03 2.036 5.03 4.726 0 2.292-1.706 3.99-3.868 3.99-1.762 0-2.985-1.022-2.985-2.463 0-.825.352-1.502 1.27-1.98a.183.183 0 0 0 .073-.258l-1.381-2.327a.187.187 0 0 0-.226-.079c-1.85.683-3.15 2.327-3.15 4.533 0 3.338 2.67 5.83 6.396 5.83 4.35 0 7.478-3 7.478-7.303 0-4.612-3.64-7.982-8.644-7.982ZM51.776 5.283c-1.68 0-3.182.62-4.277 1.707a.093.093 0 0 1-.16-.066v-1.31a.185.185 0 0 0-.187-.186h-3.235a.185.185 0 0 0-.188.187v18.702c0 .104.083.186.188.186h3.32a.185.185 0 0 0 .188-.186v-6.133c0-.082.099-.123.16-.07 1.091 1.012 2.536 1.603 4.19 1.603 3.897 0 6.936-3.139 6.936-7.217 0-4.078-3.042-7.217-6.935-7.217Zm-.63 11.266c-2.215 0-3.895-1.754-3.895-4.074S48.928 8.4 51.147 8.4c2.22 0 3.893 1.726 3.893 4.075 0 2.348-1.651 4.074-3.896 4.074h.003Z"/></svg>';
}

// ===== VARIANT HELPERS =====
function restoreAddonState(posData) {
  modal.querySelector('.print-type-input').value = posData.printType;
  modal.querySelector('.addon-size[data-addon="canvas"]').value = posData.sizeKey;
  C.syncButtonUI(modal, '.print-type-btn', 'type', posData.printType);
  C.syncButtonUI(modal, '.size-btn', 'value', posData.sizeKey);
}

function findVariant(handle, searchPattern) {
  var productData = ALL_PRODUCTS[handle];
  if (!productData) return null;
  var pattern = searchPattern.toLowerCase();
  for (var i = 0; i < productData.variants.length; i++) {
    var v = productData.variants[i];
    if (v.title.toLowerCase().includes(pattern)) {
      return { id: v.id, title: v.title, price: v.price, comparePrice: v.comparePrice };
    }
  }
  return null;
}

function getSelectedVariant(handle) {
  var sz = modal.querySelector('.addon-size[data-addon="canvas"]')?.value || '12x16';
  var printType = modal.querySelector('.print-type-input')?.value || 'canvas';
  return findVariant(handle, C.variantTitle(printType === 'framed' ? 'framed' : 'canvas', sz));
}

function getDigitalVariant(handle) { return findVariant(handle, C.VARIANT_DIGITAL); }

function updateVariant(handle) {
  var posData = getState(handle);
  var variant = getSelectedVariant(handle);
  if (variant) {
    posData.variantId = variant.id;
    posData.variantTitle = variant.title;
    posData.price = variant.price;
    posData.comparePrice = variant.comparePrice;
    updateAddonPrices(handle, variant);
  }
}

function updateAddonPrices(handle, selectedVariant) {
  var sizeSelect = modal.querySelector('.addon-size[data-addon="canvas"]');
  if (!sizeSelect) return;
  var variant = selectedVariant || findVariant(handle, C.variantTitle(
    modal.querySelector('.print-type-input')?.value || 'canvas', sizeSelect.value
  ));
  if (!variant) return;
  var atcPriceEl = modal.querySelector('.canvas-atc-price-text');
  if (atcPriceEl) atcPriceEl.textContent = C.formatMoney(variant.price);
  var digitalVariant = findVariant(handle, C.VARIANT_DIGITAL);
  modal.querySelectorAll('.digital-base-price').forEach(function(el) {
    if (digitalVariant) el.textContent = C.formatMoney(digitalVariant.price);
  });
  var installmentEl = modal.querySelector('.modal-installment-text');
  if (installmentEl) {
    var price = variant.price;
    if (price > 0) {
      var interest = price > 5000 ? 4 : 2;
      var interestNumEl = modal.querySelector('.modal-interest-num');
      var moneyInstallmentEl = modal.querySelector('.modal-money-installment');
      if (interestNumEl) interestNumEl.textContent = interest;
      if (moneyInstallmentEl) moneyInstallmentEl.textContent = C.formatMoney(Math.round(price / interest));
      installmentEl.style.display = '';
    } else {
      installmentEl.style.display = 'none';
    }
  }
}

// ===== INJECT VARIANT CARDS =====
function fetchAndInjectVariantCards(handle) {
  fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      ALL_PRODUCTS[handle] = {
        title: data.title,
        handle: data.handle,
        image: data.featured_image,
        variants: data.variants.map(function(v) {
          return { title: v.title, option1: v.option1, id: String(v.id), price: v.price, comparePrice: v.compare_at_price || v.price };
        })
      };
      variantCardsHandle = null;
      injectVariantCards(handle);
      updateAddonPrices(handle);
    })
    .catch(function(e) { console.error('Failed to fetch product data:', e); });
}

function injectVariantCards(handle) {
  if (variantCardsHandle === handle) return;
  if (isCollectionTeeCreateHandle(handle)) return;
  var productData = ALL_PRODUCTS[handle];
  if (!productData) { fetchAndInjectVariantCards(handle); return; }
  C.injectVariantCards(modalEls.variantOption, productData);
  variantCardsHandle = handle;
}


// ===== LOAD OPTIONS =====
async function loadProductOptions(handle) {
  if (!handle) return;
  if (optionsCache[handle]) {
    if (modalEls.dynamicForm.dataset.handle !== handle) {
      C.renderOptions(modalEls.dynamicForm, optionsCache[handle]);
      modalEls.dynamicForm.dataset.handle = handle;
    }
    return;
  }
  try {
    var r = await fetch(C.API_BASE_URL + '/options?product=' + handle);
    var data = await r.json();
    optionsCache[handle] = data.options || [];
    if (data.options?.length) {
      C.renderOptions(modalEls.dynamicForm, data.options);
      modalEls.dynamicForm.dataset.handle = handle;
    }
  } catch (e) { console.error(e); }
}

function photosNeedUpload(posData) {
  return (posData.localPhotos || []).some(function(photo) { return !!photo.file; });
}

function setReuseNote(picker, show) {
  if (!picker) return;
  var note = picker.querySelector('[data-reuse-upload-note]');
  if (!note) return;
  note.hidden = !show;
  if (show) note.textContent = 'Re-upload';
}

function revokeLocalPhotos(posData) {
  (posData.localPhotos || []).forEach(function(photo) {
    if (photo.previewUrl && !photo.reused) URL.revokeObjectURL(photo.previewUrl);
  });
}

function syncUploadedUrlsFromPhotos(posData) {
  var urls = (posData.localPhotos || [])
    .filter(function(photo) { return photo.uploadedUrl && !photo.file; })
    .map(function(photo) { return photo.uploadedUrl; });
  posData.uploadedUrls = urls;
  posData.uploadedUrl = urls[0] || null;
}

function renderSinglePhotoTile(posData) {
  if (!isTeeCreateSingleActive() && !isCollectionSinglePhotoActive()) return;
  var picker = modalEls.singlePicker;
  var head = picker.querySelector('.hj-multi-upload__head');
  if (head) head.hidden = (posData.localPhotos || []).length > 0;
  modalEls.singleGrid.innerHTML = '';
  var photo = posData.localPhotos && posData.localPhotos[0];
  if (photo) {
    var tile = document.createElement('div');
    tile.className = 'hj-multi-upload__tile';
    tile.innerHTML = '<img src="' + photo.previewUrl + '" alt="Uploaded photo"><button type="button" class="hj-multi-upload__remove" data-action="collection-remove-single-photo" aria-label="Remove photo">&times;</button>';
    modalEls.singleGrid.appendChild(tile);
    setReuseNote(picker, !!photo.reused);
    return;
  }

  var add = document.createElement('button');
  add.type = 'button';
  add.className = 'hj-multi-upload__tile hj-multi-upload__add';
  add.setAttribute('data-action', 'collection-add-single-photo');
  add.innerHTML = '<span class="hj-multi-upload__add-icon">+</span><span>Add photo</span>';
  modalEls.singleGrid.appendChild(add);
  setReuseNote(picker, false);
}

function renderMultiPhotoGrid(posData) {
  if (!isTeeCreateMultiActive()) return;
  var picker = modalEls.multiPicker;
  var head = picker.querySelector('.hj-multi-upload__head');
  if (head) head.hidden = (posData.localPhotos || []).length > 0;
  modalEls.multiGrid.innerHTML = '';
  (posData.localPhotos || []).forEach(function(photo, index) {
    var tile = document.createElement('div');
    tile.className = 'hj-multi-upload__tile';
    tile.innerHTML = '<img src="' + photo.previewUrl + '" alt="Uploaded photo ' + (index + 1) + '"><button type="button" class="hj-multi-upload__remove" data-action="collection-remove-multi-photo" data-index="' + index + '" aria-label="Remove photo">&times;</button>';
    modalEls.multiGrid.appendChild(tile);
  });
  if ((posData.localPhotos || []).length < MULTI_PHOTO_MAX) {
    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'hj-multi-upload__tile hj-multi-upload__add';
    add.setAttribute('data-action', 'collection-add-multi-photo');
    add.innerHTML = '<span class="hj-multi-upload__add-icon">+</span><span>Add photo</span>';
    modalEls.multiGrid.appendChild(add);
  }
  if (modalEls.multiCount) {
    var count = (posData.localPhotos || []).length;
    modalEls.multiCount.textContent = count >= MULTI_PHOTO_MIN
      ? count + ' / ' + MULTI_PHOTO_MAX + ' photos · Ready to preview'
      : count + ' / ' + MULTI_PHOTO_MAX + ' photos · Minimum ' + MULTI_PHOTO_MIN + ' required';
  }
  setReuseNote(picker, (posData.localPhotos || []).some(function(photo) { return photo.reused; }));
}

function setSinglePhotoFile(posData, file) {
  if (!file) return;
  if (!file.type.startsWith('image/') && !uploader.isHeic(file)) {
    C.showToast('Please select an image file.', 'warning');
    return;
  }
  revokeLocalPhotos(posData);
  posData.localPhotos = [{ file: file, previewUrl: URL.createObjectURL(file) }];
  posData.uploadedUrl = null;
  posData.uploadedUrls = [];
  renderSinglePhotoTile(posData);
}

function addMultiPhotoFiles(posData, files) {
  var selected = Array.prototype.slice.call(files || []);
  if (!selected.length) return;
  var current = (posData.localPhotos || []).length;
  var available = Math.max(0, MULTI_PHOTO_MAX - current);
  if (selected.length > available) C.showToast('You can upload up to 8 photos.', 'warning');
  selected.slice(0, available).forEach(function(file) {
    if (!file.type.startsWith('image/') && !uploader.isHeic(file)) {
      C.showToast('Please select image files only.', 'warning');
      return;
    }
    posData.localPhotos.push({ file: file, previewUrl: URL.createObjectURL(file) });
  });
  posData.uploadedUrl = null;
  posData.uploadedUrls = [];
  renderMultiPhotoGrid(posData);
}

function setReusedPhotos(handle, urls) {
  if (!isCollectionTeeCreate || !urls.length) return false;
  var posData = getState(handle);
  activeHandle = handle;
  if (isCollectionTeeCreateHandle(handle) && isTeeMultiPhotoHandle(handle)) {
    revokeLocalPhotos(posData);
    var validUrls = urls.slice(0, MULTI_PHOTO_MAX);
    posData.localPhotos = validUrls.map(function(url) { return { previewUrl: url, uploadedUrl: url, reused: true }; });
    posData.uploadedUrls = validUrls;
    posData.uploadedUrl = validUrls[0] || null;
    renderMultiPhotoGrid(posData);
    return true;
  }
  revokeLocalPhotos(posData);
  posData.localPhotos = [{ previewUrl: urls[0], uploadedUrl: urls[0], reused: true }];
  posData.uploadedUrl = urls[0];
  posData.uploadedUrls = [];
  renderSinglePhotoTile(posData);
  return true;
}

async function uploadTeeCreatePhotos(handle) {
  var posData = getState(handle);
  if (isTeeMultiPhotoHandle(handle)) {
    if (!posData.localPhotos || posData.localPhotos.length < MULTI_PHOTO_MIN) {
      C.showToast('Please upload at least ' + MULTI_PHOTO_MIN + ' photos.', 'warning');
      return false;
    }
    if (!photosNeedUpload(posData) && posData.uploadedUrls && posData.uploadedUrls.length >= MULTI_PHOTO_MIN) {
      posData.uploadedUrl = posData.uploadedUrls[0] || null;
      return true;
    }
    var uploadedUrls = [];
    var total = posData.localPhotos.length;
    C.showUploadStatus(modal, 'Uploading photo 1 of ' + total + '...');
    C.updateUploadStatus(modal, null, 0);
    for (var i = 0; i < posData.localPhotos.length; i++) {
      var photo = posData.localPhotos[i];
      if (photo.uploadedUrl && !photo.file) {
        uploadedUrls.push(photo.uploadedUrl);
        C.updateUploadStatus(modal, 'Loaded photo ' + (i + 1) + ' of ' + total, Math.round(((i + 1) / total) * 100));
        continue;
      }
      C.updateUploadStatus(modal, 'Uploading photo ' + (i + 1) + ' of ' + total + '...', Math.round((i / total) * 100));
      var res = await C.handleFileUpload(photo.file, uploader, modal);
      if (!res || !res.url) return false;
      uploadedUrls.push(res.url);
      C.updateUploadStatus(modal, 'Uploaded photo ' + (i + 1) + ' of ' + total, Math.round(((i + 1) / total) * 100));
    }
    C.hideUploadStatus(modal);
    posData.uploadedUrls = uploadedUrls;
    posData.uploadedUrl = uploadedUrls[0] || null;
    if (C.saveRecentUploadedUrls) C.saveRecentUploadedUrls(uploadedUrls);
    return true;
  }

  var photoSingle = posData.localPhotos && posData.localPhotos[0];
  if (posData.uploadedUrl && photoSingle && !photoSingle.file) return true;
  if (!photoSingle) {
    C.showToast('Please upload a photo first.', 'warning');
    return false;
  }
  var singleRes = await C.handleFileUpload(photoSingle.file, uploader, modal);
  if (!singleRes || !singleRes.url) return false;
  C.hideUploadStatus(modal);
  posData.uploadedUrl = singleRes.url;
  posData.uploadedUrls = [];
  return true;
}

function sizeComboHtml(name, value, sizes, attr) {
  return '<div class="combo hj-size-combo' + (attr === 'data-extra-size' ? ' hj-size-combo--sm' : '') + '">' +
    '<button type="button" class="combo-trigger hj-size-combo__trigger">' +
      '<span class="combo-label">' + escapeHtml(value) + '</span>' +
      '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' +
    '</button>' +
    '<ul class="combo-options hj-size-combo__options">' +
      sizes.map(function(size) {
        return '<li class="combo-option' + (size === value ? ' active' : '') + '" data-value="' + escapeHtml(size) + '">' + escapeHtml(size) + '</li>';
      }).join('') +
    '</ul>' +
    '<input type="hidden" class="combo-input" name="' + escapeHtml(name || '') + '" ' + attr + ' value="' + escapeHtml(value) + '">' +
  '</div>';
}

function renderTeePanel(handle) {
  if (!isCollectionTeeCreateHandle(handle) || !modalEls.teePanel) return;
  var productData = getProductData(handle);
  if (!productData) return;
  var sizes = getUniqueSizes(handle);
  var firstSize = sizes[0] || 'S';
  var secondSize = sizes.indexOf('M') !== -1 ? 'M' : firstSize;
  var firstVariant = findTeeVariantBySize(handle, firstSize);
  var posData = getState(handle);
  var designImage = posData.personalizeImage || productData.image || '';

  modalEls.teePanel.innerHTML =
    '<div class="hj-tee-modal-panel__inner hj-tee-product" data-bundle-state="single" data-state="after-gen" data-tee-modal-product data-handle="' + escapeHtml(handle) + '">' +
      '<div class="hj-tee-info__size-qty">' +
        '<div>' +
          '<div class="hj-tee-info__size-label-row"><label class="hj-tee-info__label">Size</label></div>' +
          sizeComboHtml('properties[Size Tee 1]', firstSize, sizes, 'data-tee1-size') +
          '<span data-price-tee1 data-price-raw="' + (firstVariant ? firstVariant.price : 0) + '" hidden></span>' +
        '</div>' +
        '<div>' +
          '<label class="hj-tee-info__label">Quantity</label>' +
          '<div class="hj-tee-info__qty">' +
            '<button type="button" data-qty-dec aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" value="1" min="1" class="hj-tee-info__qty-input" data-tee1-qty>' +
            '<button type="button" data-qty-inc aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="hj-tee-info__atc" data-tee-modal-atc>' +
        '<span data-atc-text>ADD 1 TEE TO CART</span>' +
        '<span class="hj-tee-atc__sep" aria-hidden="true">&middot;</span>' +
        '<span class="hj-tee-atc__price" data-atc-price>' + formatMoney(firstVariant ? firstVariant.price : 0) + '</span>' +
        '<s class="hj-tee-atc__price-old" data-atc-original-price hidden></s>' +
      '</button>' +
      '<p class="hj-tee-info__bnpl" data-tee-bnpl data-bnpl-threshold="3500">' +
        '<span data-bnpl-eligible>Pay in <span id="interest_num">2</span> interest-free installments of <strong id="moneyInstallment">$0.00</strong> with</span>' +
        '<span data-bnpl-ineligible hidden>Pay over time for orders over <strong>$35.00</strong> with</span> ' +
        '<span class="inline-flex align-middle" data-shop-pay-logo>' + shopPayLogo() + '</span>' +
      '</p>' +
      '<div class="hj-tee-info__saving" data-tee-saving hidden>' +
        '<span class="hj-tee-info__saving-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg></span>' +
        '<span data-tee-saving-text></span>' +
      '</div>' +
      '<div class="hj-tee-bundle" data-bundle-pct="15" data-bundle-pct-3="20" data-multi-size-card>' +
        '<div class="hj-tee-bundle__row-1">' +
          '<div class="hj-tee-bundle__thumb"><img src="' + designImage + '" alt="" loading="lazy" width="100" height="100" data-bundle-thumb></div>' +
          '<div class="hj-tee-bundle__info"><h3 class="hj-tee-bundle__title h4">Buy more, <em>save more.</em></h3><div class="hj-tee-bundle__sub caption-small">Add the same design in another size.</div></div>' +
        '</div>' +
        '<div class="hj-tee-bundle__list" data-extra-size-list>' +
          '<div class="hj-tee-bundle__line hj-tee-bundle__line--main"><div><span class="hj-tee-bundle__line-label caption-small">Main tee</span><strong data-main-size-display>' + escapeHtml(firstSize) + '</strong></div><div class="hj-tee-bundle__line-qty">Qty <strong data-main-qty-display>1</strong></div></div>' +
        '</div>' +
        '<button type="button" class="hj-tee-bundle__add caption-small" data-action="collection-add-extra-size"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>ADD ANOTHER SIZE</button>' +
        '<template data-extra-size-template>' +
          '<div class="hj-tee-bundle__line" data-extra-tee-row>' +
            '<div class="hj-tee-bundle__field"><label class="hj-tee-bundle__mini-label caption-small">Another size</label>' + sizeComboHtml('', secondSize, sizes, 'data-extra-size') + '</div>' +
            '<div class="hj-tee-bundle__field"><label class="hj-tee-bundle__mini-label caption-small">Qty</label><div class="hj-tee-bundle__qty"><button type="button" data-extra-qty-dec aria-label="Decrease">&minus;</button><input type="number" value="1" min="1" data-extra-qty><button type="button" data-extra-qty-inc aria-label="Increase">+</button></div></div>' +
            '<button type="button" class="hj-tee-bundle__remove" data-action="collection-remove-extra-size" aria-label="Remove size"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
          '</div>' +
        '</template>' +
      '</div>' +
    '</div>';

  modalEls.teePanel.hidden = false;
  updateTeePanel(handle);
}

function updateTeePanel(handle) {
  if (!modalEls.teePanel || modalEls.teePanel.hidden) return;
  var panel = modalEls.teePanel.querySelector('[data-tee-modal-product]');
  if (!panel) return;
  var mainSize = panel.querySelector('[data-tee1-size]')?.value || 'S';
  var mainVariant = findTeeVariantBySize(handle, mainSize);
  var priceTee1 = panel.querySelector('[data-price-tee1]');
  if (priceTee1 && mainVariant) priceTee1.dataset.priceRaw = String(mainVariant.price);
  var pricing = teePricing(panel, handle);
  var atcText = panel.querySelector('[data-atc-text]');
  var atcPrice = panel.querySelector('[data-atc-price]');
  var atcOriginal = panel.querySelector('[data-atc-original-price]');
  if (atcText) atcText.textContent = 'ADD ' + pricing.totalQty + ' TEE' + (pricing.totalQty > 1 ? 'S' : '') + ' TO CART';
  if (atcPrice) atcPrice.textContent = formatMoney(pricing.total);
  if (atcOriginal) {
    if (pricing.savings > 0) {
      atcOriginal.textContent = formatMoney(pricing.subtotal);
      atcOriginal.hidden = false;
    } else {
      atcOriginal.hidden = true;
      atcOriginal.textContent = '';
    }
  }
  var mainSizeDisplay = panel.querySelector('[data-main-size-display]');
  if (mainSizeDisplay) mainSizeDisplay.textContent = mainSize;
  var mainQtyDisplay = panel.querySelector('[data-main-qty-display]');
  if (mainQtyDisplay) mainQtyDisplay.textContent = panel.querySelector('[data-tee1-qty]')?.value || '1';

  var savingEl = panel.querySelector('[data-tee-saving]');
  if (savingEl) {
    var savingText = savingEl.querySelector('[data-tee-saving-text]');
    if (pricing.savings > 0) {
      if (savingText) savingText.textContent = 'You save ' + formatMoney(pricing.savings) + (pricing.totalQty >= 3 ? ' + free shipping' : '');
      savingEl.hidden = false;
    } else {
      if (savingText) savingText.textContent = '';
      savingEl.hidden = true;
    }
  }

  var bnpl = panel.querySelector('[data-tee-bnpl]');
  if (bnpl) {
    var threshold = parseInt(bnpl.dataset.bnplThreshold || '3500', 10);
    var eligible = bnpl.querySelector('[data-bnpl-eligible]');
    var ineligible = bnpl.querySelector('[data-bnpl-ineligible]');
    var installmentCount = bnpl.querySelector('#interest_num');
    var installment = bnpl.querySelector('#moneyInstallment');
    var isEligible = pricing.total >= threshold;
    var payments = pricing.total > 5000 ? 4 : 2;
    if (eligible) eligible.hidden = !isEligible;
    if (ineligible) ineligible.hidden = isEligible;
    if (installmentCount) installmentCount.textContent = payments;
    if (installment) installment.textContent = formatMoney(Math.round(pricing.total / payments));
  }
  panel.dataset.bundleState = panel.querySelector('[data-extra-tee-row]') ? 'bundled' : 'single';
}

async function submitTeePanel(handle, button) {
  var posData = getState(handle);
  if (!posData.personalizeImage) {
    C.showToast('Please generate your design first', 'warning');
    return;
  }
  var panel = modalEls.teePanel && modalEls.teePanel.querySelector('[data-tee-modal-product]');
  if (!panel) return;
  var pricing = teePricing(panel, handle);
  var itemsByVariant = {};
  pricing.lines.forEach(function(line) {
    if (!line.variant) return;
    var key = String(line.variant.id);
    itemsByVariant[key] = (itemsByVariant[key] || 0) + line.qty;
  });
  var items = Object.keys(itemsByVariant).map(function(variantId) {
    return {
      id: Number(variantId),
      quantity: itemsByVariant[variantId],
      properties: { '_your_design': posData.personalizeImage }
    };
  });
  if (!items.length) {
    C.showToast('Variant not found', 'error');
    return;
  }
  var original = button ? button.innerHTML : '';
  if (button) {
    button.disabled = true;
    button.textContent = 'Adding...';
  }
  try {
    await C.submitToCart(items);
    closeModal();
  } catch(err) {
    C.showToast('Failed to add to cart. Please try again.', 'error');
    if (button) {
      button.disabled = false;
      button.innerHTML = original;
    }
  }
}

// ===== PROCESS IMAGE =====
function processImage(handle) {
  var posData = getState(handle);
  var teeCreateForHandle = isCollectionTeeCreateHandle(handle);
  C.processImage({
    posData: posData,
    modal: modal,
    intervals: intervals,
    key: handle,
    onComplete: function(imageUrl) {
      modal.querySelectorAll('input[data-option-key]').forEach(function(input) { input.value = ''; });
      if (!teeCreateForHandle) updateVariant(handle);

      if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
      if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
      if (modalEls.optionsContainer) modalEls.optionsContainer.style.display = 'none';
      modalEls.modalFooter.style.display = 'none';
      modalEls.confirmBtn.classList.remove('loading');
      modalEls.confirmBtn.disabled = false;
      if (modalEls.variantOption) modalEls.variantOption.classList.toggle('hide', teeCreateForHandle);
      setDA('flex');
      if (teeCreateForHandle) renderTeePanel(handle);
    }
  });
}

// ===== MODAL =====
function openModal(handle) {
  activeHandle = handle;
  var posData = getState(handle);
  var teeCreateForHandle = isCollectionTeeCreateHandle(handle);
  modal.dataset.handle = handle;
  modalEls.productHandle.value = handle;
  var headline = modal.querySelector('.hj-modal-headline');
  if (headline) headline.innerHTML = teeCreateForHandle ? 'Personalize your <em>tee.</em>' : 'Personalize your <em>art.</em>';
  if (!teeCreateForHandle) {
    injectVariantCards(handle);
    updateAddonPrices(handle);
  }
  if (modalEls.teePanel) {
    modalEls.teePanel.hidden = true;
    modalEls.teePanel.innerHTML = '';
  }
  if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
  if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
  if (modalEls.genericPhotoPicker) modalEls.genericPhotoPicker.hidden = true;

  if (posData.personalizeImage) {
    C.setModalStep(modal, 3);
    modalEls.hacard.style.display = 'block';
    modalEls.mainImage.src = posData.personalizeImage;
    modalEls.mainImage.style.display = 'block';
    modalEls.loadingArea.style.display = 'none';
    if (modalEls.uploadedPreview) modalEls.uploadedPreview.style.display = 'none';
    modalEls.prevBtn.style.visibility = posData.listGenerated.length > 1 ? 'visible' : 'hidden';
    modalEls.nextBtn.style.visibility = posData.listGenerated.length > 1 ? 'visible' : 'hidden';
    if (modalEls.variantOption) modalEls.variantOption.classList.toggle('hide', teeCreateForHandle);
    modalEls.modalFooter.style.display = 'none';
    setDA('flex');
    if (teeCreateForHandle) {
      renderTeePanel(handle);
    } else {
      updateVariant(handle);
      restoreAddonState(posData);
    }
  } else if (posData.uploadedUrl && !teeCreateForHandle) {
    C.setModalStep(modal, isCollectionTeeCreate ? 1 : 2);
    modalEls.hacard.style.display = 'none';
    if (isCollectionTeeCreate && modalEls.singlePicker) {
      modalEls.singlePicker.hidden = false;
      renderSinglePhotoTile(posData);
      if (modalEls.uploadedPreview) modalEls.uploadedPreview.style.display = 'none';
    } else if (modalEls.uploadedPreview && modalEls.uploadedPreviewImg) {
      modalEls.uploadedPreviewImg.src = posData.uploadedUrl;
      modalEls.uploadedPreview.style.display = 'block';
    }
    if (modalEls.optionsContainer) modalEls.optionsContainer.style.display = 'none';
    modalEls.confirmBtn.querySelector('.btn-text').textContent = 'Next';
    modalEls.modalFooter.style.display = '';
    if (modalEls.variantOption) modalEls.variantOption.classList.add('hide');
    setDA('none');
  } else {
    modalEls.hacard.style.display = 'none';
    if (modalEls.uploadedPreview) modalEls.uploadedPreview.style.display = 'none';
    modalEls.optionsContainer.style.display = 'none';
    modalEls.confirmBtn.querySelector('.btn-text').textContent = 'Next';
    modalEls.modalFooter.style.display = '';
    if (modalEls.variantOption) modalEls.variantOption.classList.add('hide');
    setDA('none');
    if (teeCreateForHandle) {
      C.setModalStep(modal, 1);
      if (isTeeMultiPhotoHandle(handle) && modalEls.multiPicker) {
        modalEls.multiPicker.hidden = false;
        renderMultiPhotoGrid(posData);
      } else if (modalEls.singlePicker) {
        modalEls.singlePicker.hidden = false;
        renderSinglePhotoTile(posData);
      }
    } else if (isCollectionTeeCreate && modalEls.singlePicker) {
      C.setModalStep(modal, 1);
      modalEls.singlePicker.hidden = false;
      renderSinglePhotoTile(posData);
    } else {
      C.setModalStep(modal, 1);
      if (modalEls.genericPhotoPicker) {
        modalEls.genericPhotoPicker.hidden = false;
        modalEls.modalFooter.style.display = 'none';
      }
    }
  }
  modalEls.smallNote.style.display = posData.personalizeImage ? '' : 'none';
  if (!modal.open) {
    if (C.lockPageScroll) C.lockPageScroll();
    modal.showModal();
  }
}

async function applyLatestUpload(handle) {
  var urls = await C.getLatestUploadedUrls();
  if (!urls.length) return false;

  var posData = getState(handle);
  if (isCollectionTeeCreate) {
    if (!setReusedPhotos(handle, urls)) return false;
    openModal(handle);
    return true;
  }
  posData.uploadedUrl = urls[0];
  posData.uploadedUrls = [];
  openModal(handle);
  if (isCollectionTeeCreate) return true;

  C.setModalStep(modal, 2);
  modalEls.hacard.style.display = 'none';
  if (modalEls.uploadedPreview && modalEls.uploadedPreviewImg) {
    modalEls.uploadedPreviewImg.src = urls[0];
    modalEls.uploadedPreview.style.display = 'block';
  }
  modalEls.confirmBtn.classList.add('loading');
  modalEls.confirmBtn.disabled = true;

  C.updateUploadStatus(modal, 'Loading options...', 100);
  await loadProductOptions(handle);
  C.hideUploadStatus(modal);
  updateAddonPrices(handle);

  var hasOptions = optionsCache[handle] && optionsCache[handle].length > 0;
  if (hasOptions) {
    modalEls.optionsContainer.style.display = 'block';
    modalEls.confirmBtn.classList.remove('loading');
    modalEls.confirmBtn.disabled = false;
  } else {
    posData.options = {};
    modalEls.optionsContainer.style.display = 'none';
    processImage(handle);
  }
  return true;
}

function closeModal() {
  var handle = activeHandle;
  if (modal.open) modal.close();
  if (C.unlockPageScroll) C.unlockPageScroll();
  if (handle) C.clearIntervals(intervals, handle);
  modalEls.confirmBtn.classList.remove('loading');
  modalEls.confirmBtn.disabled = false;
  activeHandle = null;
}

// ===== INIT =====
function init() {
  // Combo dropdown handler
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.combo-trigger');
    if (trigger) {
      var combo = trigger.closest('.combo');
      var open = combo.classList.contains('open');
      document.querySelectorAll('.combo.open').forEach(function(c) { c.classList.remove('open'); });
      document.querySelectorAll('.combo-trigger.active').forEach(function(t) { t.classList.remove('active'); });
      if (!open) { combo.classList.add('open'); trigger.classList.add('active'); }
      return;
    }
    var option = e.target.closest('.combo-option');
    if (option) {
      var combo = option.closest('.combo');
      combo.querySelectorAll('.combo-option').forEach(function(o) { o.classList.remove('active'); });
      option.classList.add('active');
      combo.querySelector('.combo-label').textContent = option.innerText.replace('\u2713', '').trim();
      var value = option.dataset.value;
      if (value) {
        var hiddenInput = combo.querySelector('.combo-input');
        if (hiddenInput) { hiddenInput.value = value; hiddenInput.dispatchEvent(new Event('change', {bubbles: true})); }
      }
      combo.classList.remove('open');
      combo.querySelector('.combo-trigger').classList.remove('active');
      if (isCollectionTeeCreateHandle(activeHandle) && activeHandle && modalEls.teePanel && modalEls.teePanel.contains(combo)) {
        updateTeePanel(activeHandle);
      }
      return;
    }
    if (!e.target.closest('.combo')) {
      document.querySelectorAll('.combo.open').forEach(function(c) { c.classList.remove('open'); });
      document.querySelectorAll('.combo-trigger.active').forEach(function(t) { t.classList.remove('active'); });
    }
  });

  // Upload trigger
  document.addEventListener('click', function(e) {
    var uploadBtn = e.target.closest('.upload-trigger');
    if (!uploadBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = uploadBtn.dataset.handle;
    if (!handle) return;

    state[handle] = createState();
    state[handle].productHandle = handle;
    var posData = getState(handle);
    var teeCreateForHandle = isCollectionTeeCreateHandle(handle);
    if (teeCreateForHandle) openModal(handle);

    if (!teeCreateForHandle && !posData.variantId) {
      var digitalVariant = findVariant(handle, C.VARIANT_DIGITAL);
      if (digitalVariant) {
        posData.variantId = digitalVariant.id;
        posData.variantTitle = digitalVariant.title;
        posData.price = digitalVariant.price;
        posData.comparePrice = digitalVariant.comparePrice;
      } else {
        posData.variantId = uploadBtn.dataset.defaultVariantId;
        posData.price = parseInt(uploadBtn.dataset.defaultPrice) || 0;
        posData.comparePrice = parseInt(uploadBtn.dataset.defaultComparePrice) || 0;
        posData.variantTitle = C.VARIANT_DIGITAL;
      }
    }

    fileInput.dataset.handle = handle;
    if (teeCreateForHandle && isTeeMultiPhotoHandle(handle)) fileInput.setAttribute('multiple', 'multiple');
    else fileInput.removeAttribute('multiple');
    applyLatestUpload(handle).then(function(reused) {
      if (!reused) {
        openModal(handle);
        if (!isCollectionTeeCreate) fileInput.click();
      }
    });
  });

  function openPickerAfterReloadIfNeeded() {
    var shouldOpen = false;
    try {
      shouldOpen = window.sessionStorage.getItem('hjOpenPickerAfterReload') === '1';
      if (shouldOpen) window.sessionStorage.removeItem('hjOpenPickerAfterReload');
    } catch (error) {}
    if (!shouldOpen) return;

    var uploadBtn = document.querySelector('.upload-trigger');
    if (!uploadBtn) return;
    window.setTimeout(function() {
      uploadBtn.click();
    }, 350);
  }

  // File input
  fileInput.addEventListener('change', async function(e) {
    var handle = fileInput.dataset.handle;
    if (!handle) return;
    var posData = getState(handle);

    if (e.target.closest('[data-action="generic-upload-photo"]')) {
      e.preventDefault();
      fileInput.dataset.handle = handle;
      fileInput.removeAttribute('multiple');
      fileInput.click();
      return;
    }

    if (isCollectionTeeCreate) {
      activeHandle = handle;
      openModal(handle);
      if (isCollectionTeeCreateHandle(handle) && isTeeMultiPhotoHandle(handle)) {
        addMultiPhotoFiles(posData, e.target.files);
      } else {
        setSinglePhotoFile(posData, e.target.files && e.target.files[0]);
      }
      fileInput.value = '';
      return;
    }

    var f = e.target.files[0];
    if (!f) return;
    var localPreview = URL.createObjectURL(f);

    openModal(handle);
    if (modalEls.genericPhotoPicker) modalEls.genericPhotoPicker.hidden = true;
    C.setModalStep(modal, 1);
    if (modalEls.uploadedPreviewImg) modalEls.uploadedPreviewImg.src = localPreview;
    if (modalEls.uploadedPreview) modalEls.uploadedPreview.style.display = 'block';
    modalEls.hacard.style.display = 'none';
    modalEls.confirmBtn.classList.add('loading');
    modalEls.confirmBtn.disabled = true;

    try {
      var res = await C.handleFileUpload(f, uploader, modal);
      if (!res) { modalEls.confirmBtn.classList.remove('loading'); modalEls.confirmBtn.disabled = false; return; }

      URL.revokeObjectURL(localPreview);
      posData.uploadedUrl = res.url;
      modalEls.uploadedPreviewImg.src = res.url;

      C.updateUploadStatus(modal, 'Loading options...', 100);
      await loadProductOptions(handle);

      C.hideUploadStatus(modal);
      C.setModalStep(modal, 2);
      updateAddonPrices(handle);
      var hasOptions = optionsCache[handle] && optionsCache[handle].length > 0;
      if (hasOptions) {
        modalEls.optionsContainer.style.display = 'block';
        modalEls.confirmBtn.classList.remove('loading');
        modalEls.confirmBtn.disabled = false;
      } else {
        posData.options = {};
        modalEls.optionsContainer.style.display = 'none';
        processImage(handle);
      }
    } catch (err) {
      console.error('Upload error:', err);
      URL.revokeObjectURL(localPreview);
      C.hideUploadStatus(modal);
      C.showToast(C.uploadErrorMessage(err), 'error');
      modalEls.confirmBtn.classList.remove('loading');
      modalEls.confirmBtn.disabled = false;
      modalEls.confirmBtn.querySelector('.btn-text').textContent = 'Next';
      modalEls.uploadedPreview.style.display = 'none';
    }
    fileInput.value = '';
  });

  // Modal button clicks
  modal.addEventListener('click', async function(e) {
    var handle = activeHandle;
    if (!handle) return;
    var posData = getState(handle);

    if (isCollectionTeeCreate) {
      var teeAtc = e.target.closest('[data-tee-modal-atc]');
      if (teeAtc && isCollectionTeeCreateHandle(handle)) {
        e.preventDefault();
        submitTeePanel(handle, teeAtc);
        return;
      }

      if (e.target.closest('[data-action="collection-add-single-photo"]')) {
        e.preventDefault();
        fileInput.removeAttribute('multiple');
        fileInput.click();
        return;
      }

      if (e.target.closest('[data-action="collection-remove-single-photo"]')) {
        e.preventDefault();
        revokeLocalPhotos(posData);
        posData.localPhotos = [];
        posData.uploadedUrl = null;
        posData.uploadedUrls = [];
        renderSinglePhotoTile(posData);
        return;
      }

      if (e.target.closest('[data-action="collection-add-multi-photo"]') && isCollectionTeeCreateHandle(handle) && isTeeMultiPhotoHandle(handle)) {
        e.preventDefault();
        fileInput.setAttribute('multiple', 'multiple');
        fileInput.click();
        return;
      }

      var removeMulti = e.target.closest('[data-action="collection-remove-multi-photo"]');
      if (removeMulti) {
        e.preventDefault();
        var removeIndex = parseInt(removeMulti.dataset.index || '-1', 10);
        if (removeIndex >= 0 && posData.localPhotos && posData.localPhotos[removeIndex]) {
          if (!posData.localPhotos[removeIndex].reused && posData.localPhotos[removeIndex].previewUrl) {
            URL.revokeObjectURL(posData.localPhotos[removeIndex].previewUrl);
          }
          posData.localPhotos.splice(removeIndex, 1);
          syncUploadedUrlsFromPhotos(posData);
          renderMultiPhotoGrid(posData);
        }
        return;
      }

      if (e.target.closest('[data-action="reuse-upload-new"]')) {
        e.preventDefault();
        revokeLocalPhotos(posData);
        posData.localPhotos = [];
        posData.uploadedUrl = null;
        posData.uploadedUrls = [];
        if (isCollectionTeeCreateHandle(handle) && isTeeMultiPhotoHandle(handle)) {
          renderMultiPhotoGrid(posData);
          fileInput.setAttribute('multiple', 'multiple');
        } else {
          renderSinglePhotoTile(posData);
          fileInput.removeAttribute('multiple');
        }
        fileInput.click();
        return;
      }

      var addExtra = e.target.closest('[data-action="collection-add-extra-size"]');
      if (addExtra) {
        e.preventDefault();
        var panel = modalEls.teePanel.querySelector('[data-tee-modal-product]');
        var list = panel && panel.querySelector('[data-extra-size-list]');
        var template = panel && panel.querySelector('[data-extra-size-template]');
        if (list && template) {
          var node = template.content.firstElementChild.cloneNode(true);
          var usedSizes = teePricing(panel, handle).lines.map(function(line) { return line.size; });
          var options = Array.prototype.slice.call(node.querySelectorAll('.combo-option'));
          var next = options.find(function(option) { return usedSizes.indexOf(option.dataset.value) === -1; }) || options[0];
          if (next) {
            var value = next.dataset.value;
            options.forEach(function(option) { option.classList.toggle('active', option === next); });
            var label = node.querySelector('.combo-label');
            var input = node.querySelector('[data-extra-size]');
            if (label) label.textContent = value;
            if (input) input.value = value;
          }
          list.appendChild(node);
          updateTeePanel(handle);
        }
        return;
      }

      var removeExtra = e.target.closest('[data-action="collection-remove-extra-size"]');
      if (removeExtra) {
        e.preventDefault();
        var row = removeExtra.closest('[data-extra-tee-row]');
        if (row) row.remove();
        updateTeePanel(handle);
        return;
      }

      var qtyBtn = e.target.closest('[data-qty-dec],[data-qty-inc],[data-extra-qty-dec],[data-extra-qty-inc]');
      if (qtyBtn) {
        e.preventDefault();
        var rowScope = qtyBtn.closest('[data-extra-tee-row]');
        var input = rowScope ? rowScope.querySelector('[data-extra-qty]') : modalEls.teePanel.querySelector('[data-tee1-qty]');
        if (input) {
          var nextQty = Math.max(1, parseInt(input.value || '1', 10) + (qtyBtn.matches('[data-qty-inc],[data-extra-qty-inc]') ? 1 : -1));
          input.value = nextQty;
          updateTeePanel(handle);
        }
        return;
      }
    }

    if (e.target.closest('[data-close]') || e.target.closest('.modal-atc-btn')) { closeModal(); return; }

    if (e.target.closest('.generate-btn')) {
      if (!C.isProcessing(intervals, handle)) {
        if (modalEls.teePanel) modalEls.teePanel.hidden = true;
        setDA('none'); processImage(handle);
      }
      return;
    }

    if (e.target.closest('.prev-btn')) {
      var idx = posData.galleryIndex - 1;
      if (idx >= 0) { posData.galleryIndex = idx; posData.personalizeImage = posData.listGenerated[idx]; modalEls.mainImage.src = posData.personalizeImage; }
      return;
    }
    if (e.target.closest('.next-btn')) {
      var idx = posData.galleryIndex + 1;
      if (idx < posData.listGenerated.length) { posData.galleryIndex = idx; posData.personalizeImage = posData.listGenerated[idx]; modalEls.mainImage.src = posData.personalizeImage; }
      return;
    }

    var printTypeBtn = e.target.closest('.print-type-btn');
    if (printTypeBtn) {
      e.stopPropagation();
      posData.printType = printTypeBtn.dataset.type;
      modal.querySelector('.print-type-input').value = posData.printType;
      C.syncButtonUI(modal, '.print-type-btn', 'type', posData.printType);
      updateVariant(handle);
      return;
    }

    var sizeBtn = e.target.closest('.size-btn');
    if (sizeBtn) {
      e.stopPropagation();
      posData.sizeKey = sizeBtn.dataset.value;
      var sizeInput = modal.querySelector('.addon-size[data-addon="canvas"]');
      if (sizeInput) sizeInput.value = sizeBtn.dataset.value;
      C.syncButtonUI(modal, '.size-btn', 'value', sizeBtn.dataset.value);
      updateVariant(handle);
      return;
    }

    if (e.target.closest('.download-now-btn')) {
      var btn = e.target.closest('.download-now-btn');
      closeModal();
      var dv = getDigitalVariant(handle);
      if (!dv) { C.showToast('Digital variant not found', 'error'); return; }
      var cartProps = C.buildCartProperties(posData);
      btn.disabled = true; btn.textContent = 'Processing...';
      try {
        await C.submitToCart([{ id: dv.id, quantity: 1, properties: cartProps }]);
        state[handle] = createState();
        state[handle].productHandle = handle;
      }
      catch(err) { C.showToast('Failed to add to cart. Please try again.', 'error'); btn.disabled = false; btn.textContent = 'Download Now'; }
      return;
    }

    if (e.target.closest('.canvas-atc-btn')) {
      var btn = e.target.closest('.canvas-atc-btn');
      updateVariant(handle);
      var cartProps = C.buildCartProperties(posData);
      var variantId = posData.variantId;
      closeModal();
      state[handle] = createState();
      state[handle].productHandle = handle;
      var originalHTML = btn.innerHTML;
      btn.disabled = true; btn.textContent = 'Adding...';
      try { await C.submitToCart([{ id: variantId, quantity: 1, properties: cartProps }]); }
      catch(err) { C.showToast('Failed to add to cart. Please try again.', 'error'); }
      btn.disabled = false; btn.innerHTML = originalHTML;
      return;
    }

    if (e.target.closest('.confirm-btn')) {
      if (isCollectionTeeCreateHandle(handle)) {
        if (posData.personalizeImage) return;

        var teeRequiredInputs = modal.querySelectorAll('[data-option-key][required]');
        var teeHasErrors = false;
        if (modalEls.optionsContainer.style.display !== 'none') {
          teeRequiredInputs.forEach(function(input) {
            if (!input.value.trim()) { input.style.borderColor = '#dc3545'; teeHasErrors = true; }
            else { input.style.borderColor = ''; }
          });
          if (teeHasErrors) { C.showToast('Please fill in all required fields', 'warning'); return; }
          posData.options = C.collectOptionValues(modal);
          posData.optionLabels = C.collectOptionLabels(modal);
          modalEls.optionsContainer.style.display = 'none';
          modalEls.confirmBtn.classList.add('loading');
          modalEls.confirmBtn.disabled = true;
          C.setModalStep(modal, 3);
          processImage(handle);
          return;
        }

        modalEls.confirmBtn.classList.add('loading');
        modalEls.confirmBtn.disabled = true;
        try {
          var ready = await uploadTeeCreatePhotos(handle);
          if (!ready) {
            modalEls.confirmBtn.classList.remove('loading');
            modalEls.confirmBtn.disabled = false;
            return;
          }
          C.updateUploadStatus(modal, 'Loading options...', 100);
          await loadProductOptions(handle);
          C.hideUploadStatus(modal);
          var hasTeeOptions = optionsCache[handle] && optionsCache[handle].length > 0;
          if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
          if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
          if (hasTeeOptions) {
            C.setModalStep(modal, 2);
            modalEls.optionsContainer.style.display = 'block';
            modalEls.confirmBtn.classList.remove('loading');
            modalEls.confirmBtn.disabled = false;
          } else {
            posData.options = {};
            posData.optionLabels = {};
            modalEls.optionsContainer.style.display = 'none';
            C.setModalStep(modal, 3);
            processImage(handle);
          }
        } catch (err) {
          console.error(err);
          C.hideUploadStatus(modal);
          C.showToast('Processing failed. Please try again.', 'error');
          modalEls.confirmBtn.classList.remove('loading');
          modalEls.confirmBtn.disabled = false;
        }
        return;
      }

      if (posData.personalizeImage) {
        if (!posData.variantId) { C.showToast('Please select a variant', 'warning'); return; }
        closeModal();
        return;
      }
      if (isCollectionTeeCreate && isModalStepActive(1) && (posData.uploadedUrl || (posData.localPhotos || []).length)) {
        modalEls.confirmBtn.classList.add('loading');
        modalEls.confirmBtn.disabled = true;
        try {
          var collectionSourceReady = true;
          if (!posData.uploadedUrl) collectionSourceReady = await uploadTeeCreatePhotos(handle);
          if (!collectionSourceReady) {
            modalEls.confirmBtn.classList.remove('loading');
            modalEls.confirmBtn.disabled = false;
            return;
          }
          C.updateUploadStatus(modal, 'Loading options...', 100);
          await loadProductOptions(handle);
          C.hideUploadStatus(modal);
          updateAddonPrices(handle);
          var hasCollectionArtOptions = optionsCache[handle] && optionsCache[handle].length > 0;
          if (hasCollectionArtOptions) {
            C.setModalStep(modal, 2);
            if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
            if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
            modalEls.optionsContainer.style.display = 'block';
            modalEls.confirmBtn.classList.remove('loading');
            modalEls.confirmBtn.disabled = false;
          } else {
            posData.options = {};
            posData.optionLabels = {};
            if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
            if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
            modalEls.optionsContainer.style.display = 'none';
            C.setModalStep(modal, 3);
            processImage(handle);
          }
        } catch (err) {
          console.error(err);
          C.hideUploadStatus(modal);
          C.showToast('Processing failed. Please try again.', 'error');
          modalEls.confirmBtn.classList.remove('loading');
          modalEls.confirmBtn.disabled = false;
        }
        return;
      }
      var requiredInputs = modal.querySelectorAll('[data-option-key][required]');
      var hasErrors = false;
      requiredInputs.forEach(function(input) {
        if (!input.value.trim()) { input.style.borderColor = '#dc3545'; hasErrors = true; }
        else { input.style.borderColor = ''; }
      });
      if (hasErrors) { C.showToast('Please fill in all required fields', 'warning'); return; }
      if (!posData.uploadedUrl) { C.showToast('Please upload an image first', 'warning'); return; }

      modalEls.confirmBtn.classList.add('loading');
      modalEls.confirmBtn.disabled = true;
      try {
        posData.options = C.collectOptionValues(modal);
        posData.optionLabels = C.collectOptionLabels(modal);
        if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
        if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
        modalEls.optionsContainer.style.display = 'none';
        C.setModalStep(modal, 3);
        processImage(handle);
      } catch (err) {
        console.error(err);
        C.showToast('Processing failed. Please try again.', 'error');
        modalEls.confirmBtn.classList.remove('loading');
        modalEls.confirmBtn.disabled = false;
      }
    }
  });

  modal.addEventListener('input', function(e) {
    if (!isCollectionTeeCreateHandle(activeHandle) || !activeHandle) return;
    if (!e.target.matches('[data-tee1-qty],[data-extra-qty]')) return;
    var value = Math.max(1, parseInt(e.target.value || '1', 10));
    e.target.value = value;
    updateTeePanel(activeHandle);
  });

  modal.addEventListener('cancel', function(e) {
    e.preventDefault();
    if (activeHandle) closeModal();
    else modal.close();
  });

  setTimeout(function() {
    var firstBtn = document.querySelector('.personalize-btn:not(.done)');
    if (firstBtn) {
      firstBtn.classList.add('attention');
      firstBtn.addEventListener('animationend', function() { firstBtn.classList.remove('attention'); }, { once: true });
    }
  }, 800);

  openPickerAfterReloadIfNeeded();

  document.querySelectorAll('#product-grid > li[data-handle]').forEach(function(card) {
    card.addEventListener('pointerenter', function() {
      var handle = card.dataset.handle;
      if (handle && !ALL_PRODUCTS[handle]) fetchAndInjectVariantCards(handle);
    }, { once: true });
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

})();
